import axios from 'axios';

const digipayLocationService = axios.create({
  // baseURL: 'https://7ze1bx9bu5.execute-api.ap-southeast-1.amazonaws.com/development',
  baseURL: 'https://gqcphg1gpf.execute-api.ap-southeast-1.amazonaws.com/production',
  headers: {
    'Content-Type': 'application/json',
  },
});

export default digipayLocationService;
// "proxy": "https://7ze1bx9bu5.execute-api.ap-southeast-1.amazonaws.com/development"